<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import config from '@/config.js'

export default {
    name: 'App',
    mounted(){

        //Google Analytics - GTAG
        let analyticsGtagScriptSRC = document.createElement('script');
        let analyticsGtagScript = document.createElement('script');
        
        analyticsGtagScriptSRC.setAttribute('src', `//www.googletagmanager.com/gtag/js?id=${config.GOOGLE_UA_GTAG_CODE}`)
        analyticsGtagScript.innerText = 
        `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${config.GOOGLE_UA_GTAG_CODE}');
        `;

        document.head.appendChild(analyticsGtagScriptSRC);
        document.head.appendChild(analyticsGtagScript);


        //Google Adwords - GTAG
        let adwordsGtagScriptSRC = document.createElement('script');
        let adwordsGtagScript = document.createElement('script');
        
        adwordsGtagScriptSRC.setAttribute('src', `//www.googletagmanager.com/gtag/js?id=${config.GOOGLE_AW_GTAG_CODE}`)
        adwordsGtagScript.innerText = 
        `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${config.GOOGLE_AW_GTAG_CODE}');
        `;
        document.head.appendChild(adwordsGtagScriptSRC);
        document.head.appendChild(adwordsGtagScript);

        //Google-Adwords Conversion Tag -> Display only on Thank You page
        if((this.$route.path).toLowerCase() == '/3dsecuresuccess'){
            let adwordsConversionScript = document.createElement('script');
            adwordsConversionScript.innerText = 
            `
            gtag('event', 'conversion', { 'send_to': '${config.GOOGLE_AW_GTAG_CODE}/LByXCNSwsPYCEJrrus4C', 'transaction_id': '' });
            `;
            document.head.appendChild(adwordsConversionScript);
            console.log('conversion tracked');
        }

        //Google Analytics - GTM
        if(config.GOOGLE_GTM_CODE !== 'NO_TAG_MANAGER'){
            let gtmScript = document.createElement('script');
            gtmScript.innerText = 
            `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${config.GOOGLE_GTM_CODE}');
            `;
            document.head.appendChild(gtmScript);
        }

        //Facebook Pixel
        if(config.FACEBOOK_PIXEL_CODE !== 'NO_FACEBOOK_PIXEL'){
            let pixelScript = document.createElement('script');
            pixelScript.innerText = 
            `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${config.FACEBOOK_PIXEL_CODE}');
            fbq('track', 'PageView');
            `;
            document.head.appendChild(pixelScript);
        }

        //Hotjar Script
        let hotjarScript = document.createElement('script');
        hotjarScript.innerText = 
        `
        (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${config.HOTJAR_ID},hjsv:${config.HOTJAR_SV}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
        document.head.appendChild(hotjarScript);
    }
}
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
</style>